/**
 * Created by tofael on 11/5/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import { DatePicker, MenuItem, RaisedButton, SelectField, TextField } from 'material-ui';

import {Map} from 'immutable';
import api from '../utility/api';
import List from '../screens/list/';
import utils from '../utility/utils';
import { white, green500 } from "material-ui/styles/colors";

import appConstants from '../utility/app-constants';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';
import MissionDetailsDialog from '../screens/shared/mission-detail-dialog';
import { getListUIPreference, setListUIPreference, getUser } from '../utility/local-storage';

class MissionList extends React.Component {

  constructor() {
    super(...arguments);
    let {defaultSort, pageSize} = this.loadUIPreferences();
    const role = this.getRole();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - 14);
    this.state = {
      missions: Map(),
      startDate,
      role,
      endDate: new Date(),
      docNamesSet: new Set(),
      opNamesSet: new Set(),
      patNamesSet: new Set(),
      missionNumSet: new Set(),
      callerPhonesSet: new Set(),
      symptomsSet: new Set(),
      factoryNameSet: new Set(),
      counsellingSet: new Set(),
      covidRelatedSet: new Set(),
      callerPhone:null,
      docName: '',
      opName: '',
      patName: '',
      missionNumber: '',
      symptom: '',
      factoryName: '',
      counselling: '',
      covidRelated: '',
      sortPref: defaultSort,
      pageSize,
      selectedMission: null,
      missionDetailsDialogOpen: false,
      comment: '',
      review: '',
      endMissionDialogOpen: false,
      reopenMissionDialogOpen: false,
      reviewDialogOpen: false,
      total:0,
      selectedReport: null,
      options: ["Yes", "No"],
      selectedCounselling: '',
      selectedCovidRelated: '',
    };
  }

  loadUIPreferences() {
    let listPreference = getListUIPreference(appConstants.LIST.MISSION);
    let defaultSort = listPreference && listPreference.sortPref ? listPreference.sortPref :
      [
        {
          id: 'date',
          desc: true
        }
      ];
    let pageSize = listPreference && listPreference.sortPref ? listPreference.pageSize : 20;

    return {defaultSort, pageSize};
  }

  onSortedChange(newSorted){
    let currentPreference = getListUIPreference(appConstants.LIST.MISSION);
    currentPreference = currentPreference || {};
    currentPreference.sortPref = newSorted;
    setListUIPreference(appConstants.LIST.MISSION, currentPreference);
  }

  onPageSizeChange(pageIndex) {
    let currentPreference = getListUIPreference(appConstants.LIST.MISSION);
    currentPreference = currentPreference || {};
    currentPreference.pageSize = pageIndex;
    setListUIPreference(appConstants.LIST.MISSION, currentPreference);
  }

  displayFeedBack(message){
    this.props.dispatch(showFeedback({message: message}));
  }

  componentDidMount() {
    // this.props.dispatch(asyncStart());
  }

  toggleMissionDetailDialog = () => {
    this.setState({ missionDetailsDialogOpen: !this.state.missionDetailsDialogOpen });
  };

  toggleEndMissionDialog = () => {
    this.setState({ endMissionDialogOpen: !this.state.endMissionDialogOpen, comment: '' });
  };

  toggleReopenMissionDialog = () => {
    this.setState({ reopenMissionDialogOpen: !this.state.reopenMissionDialogOpen, comment: '' });
  };

  dispatchAction(action){
    this.props.dispatch(action());
  }

  getRole() {
    let roles = '';
       if (getUser() && (getUser().rmg)) {
      roles = 'RMG'
    }
       if (getUser() && (getUser().scheduler)) {
      roles = 'Scheduler'
    }
      if (getUser() && (getUser().admin || getUser().operator)) {
      roles = 'Admin';
    }
      if (getUser() && getUser().super_admin) {
      roles = 'Super Admin';
    }
    return roles;
  }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  handleCounsellingSelect = (_, __, selectedCounselling) =>{
    this.setState({selectedCounselling})
    this.setState({counselling: selectedCounselling})
  }

  handleCovidRelatedSelect = (_, __, selectedCovidRelated) =>{
    this.setState({selectedCovidRelated})
    this.setState({covidRelated: selectedCovidRelated})
  }

  onDateChange(dateType, _, date) {
    this.setState({ [dateType]: date });
  }

  toggleReviewDialog = () => {
    this.setState({ reviewDialogOpen: !this.state.reviewDialogOpen});
  };

  submitReview = () => {
    let {selectedMission, review} = this.state;
    let missionId = selectedMission.id;
    if (!review) return;

    api
      .submitMissionReview(missionId, review)
      .then((review) => {
        this.toggleReviewDialog();
        this.setState({ review: '' });
        let currentMission = this.state.missions.get(missionId);
        currentMission.reviews = currentMission.reviews.concat(review);
        this.setState({
          missions: this.state.missions.set(missionId, currentMission)
        });
        this.displayFeedBack(`Mission review has been submitted successfully.`);
      })
      .catch((err)=>{
        this.showFeedback(err.message);
      });

  };
  getMissions(){
    this.props.dispatch(asyncStart());
    const { startDate, endDate, docName, opName, patName, callerPhone, missionNumber, symptom, counselling, covidRelated, role } = this.state;
    api.getMissions(startDate, endDate, docName, opName, patName, callerPhone, missionNumber, symptom, counselling, covidRelated, role)
      .then(missions => {
        this.props.dispatch(asyncEnd());
        let missionMap = Map();
        const docNamesSet = new Set(), opNamesSet = new Set(), patNamesSet = new Set(), callerPhonesSet = new Set(), missionNumSet = new Set(), symptomsSet = new Set(), counsellingSet = new Set(), covidRelatedSet = new Set();
        missions.forEach((mission) => {
          const { id, mission_number, assignee, doctor, patient, initial_conditions, counselling, covid_related } = mission;
          missionMap = missionMap.set(id, mission);
          if (doctor) {
            docNamesSet.add(doctor.user.name);
          }
          if (assignee) {
            opNamesSet.add(assignee.name);
          }
          if (patient) {
            patNamesSet.add(patient.name);
          }
          if (patient) {
            callerPhonesSet.add(patient.user.phone)
          }
          if (mission_number) {
            missionNumSet.add(mission_number)
          }
          if (symptom) {
            symptomsSet.add(initial_conditions)
          }
          if (counselling) {
            counsellingSet.add(counselling)
          }
          if (covidRelated) {
            covidRelatedSet.add(covid_related)
          }
        });
        this.setState({
          missions: missionMap,
          total: missions.length,
          docNamesSet,
          opNamesSet,
          patNamesSet,
          callerPhonesSet,
          missionNumSet,
          symptomsSet,
          counsellingSet,
          covidRelatedSet
        });
        let queryMissionId = this.props.location.query.id;
        if (queryMissionId && missionMap.get(queryMissionId)) {
          this.setState({
            selectedMission: missionMap.get(queryMissionId),
            missionDetailsDialogOpen: true
          });
        }
        //this.setState({missions: missions});
      })
      .catch(error => {
        console.error(error);
        this.props.dispatch(asyncEnd());
        this.displayFeedBack(error.message);
      });
  }

  reopenMission(mission){
    this.dispatchAction(asyncStart);
    let {selectedMission, comment} = this.state;
    api.reopenMission(selectedMission.id, comment)
      .then(mission => {
        this.setState({
          missions: this.state.missions.set(mission.id, mission)
        });
        this.toggleReopenMissionDialog();
        this.toggleMissionDetailDialog();
        this.displayFeedBack(`Mission reopened successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  }

  toggleTestMissionFlag(mission){
    this.dispatchAction(asyncStart);
    let {id: missionId} = mission;
    api.toggleTestMissionFlag(missionId)
      .then(mission => {
        this.setState({
          missions: this.state.missions.set(mission.id, mission)
        });
        this.toggleMissionDetailDialog();
        this.displayFeedBack(`Mission marked as test`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  }

  endMission(mission){
    this.dispatchAction(asyncStart);
    let {selectedMission, comment} = this.state;
    api.endMission(selectedMission.id, comment)
      .then(mission => {
        this.setState({
          missions: this.state.missions.set(mission.id, mission)
        });
        this.toggleEndMissionDialog();
        this.toggleMissionDetailDialog();
        this.displayFeedBack(`Mission ended successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
      });
  }

  uploadPrescription = (selectedFiles) =>{
    this.dispatchAction(asyncStart);
    let {selectedMission} = this.state;
    let form_data = new FormData();
    
    form_data.append('missionId', selectedMission.id);

    for(let i = 0; i < selectedFiles.length; i++) {
      form_data.append('prescription', selectedFiles[i]);
    }

    return api.uploadPrescriptionFile(form_data)
      .then(mission => {
        this.setState({
          missions: this.state.missions.set(mission.id, mission),
          selectedMission: mission
        });
        this.displayFeedBack(`Prescription uploaded successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  };

  uploadReport = (selectedFiles, selectedReportType) =>{
    this.dispatchAction(asyncStart);
    let {selectedMission} = this.state;
    let form_data = new FormData();

    for(let i = 0; i < selectedFiles.length; i++) {
        form_data.append('report', selectedFiles[i]);
      }  
      
    form_data.append('missionId', selectedMission.id);
    form_data.append('reportType', selectedReportType);
    return api.uploadMissionReport(form_data)
      .then(mission => {
        this.setState({
          missions: this.state.missions.set(mission.id, mission),
          selectedMission: mission
        });
        this.displayFeedBack(`Mission report uploaded successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  };

  deleteReport = (reportId)=>{
    this.dispatchAction(asyncStart);
    return api.deleteMissionInvestigationReport(reportId)
      .then(mission => {
        this.setState({
          missions: this.state.missions.set(mission.id, mission),
          selectedMission: mission
        });
        this.displayFeedBack(`Mission report deleted successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  };

  startInvestigation = () => {
    this.dispatchAction(asyncStart);
    const {selectedMission} = this.state;
    const missionId = selectedMission.id;

    api.startMissionInvestigation(missionId)
    .then(() => {
      api.getMissionDetails(missionId)
        .then(mission => {
        this.setState({
          missions: this.state.missions.set(missionId, mission),
          selectedMission: mission
        });
      })
        this.displayFeedBack(`Investigation started successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });
  }

  endInvestigation = () => {
    this.dispatchAction(asyncStart);
    const {selectedMission} = this.state;
    const missionId = selectedMission.id;

    api.endMissionInvestigation(missionId)
      .then(() => {
      api.getMissionDetails(missionId)
        .then(mission => {
        this.setState({
          missions: this.state.missions.set(missionId, mission),
          selectedMission: mission
        });
      })
        this.displayFeedBack(`Investigation ended successfully`);
        this.dispatchAction(asyncEnd);
      })
      .catch(error => {
        this.dispatchAction(asyncEnd);
        this.displayFeedBack(error.message);
      });

  }


  render() {
    let columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false
      },
      {
        id: 'date',
        Header: 'Date',
        accessor: d =>  new Date(d.created_at),
        Cell: props => <span>{utils.toAppDate(props.value)} {props.original.test ? '(TEST MISSION)' : ''}</span>,
        filterMethod: (filter, row) => {
          return filter === null || filter.value === null ||utils.isSameDay(filter.value, row[filter.id])
        },
        Filter: ({ filter, onChange }) =>
          <DatePicker
            cancelLabel='Clear'
            textFieldStyle={{height: '100%', position: 'inherit'}}
            value={filter ? filter.value : null}
            onDismiss={()=> onChange(null)}
            onChange={(event, date) => onChange(date)}
          />
      },
      {
        Header: 'Patient',
        accessor: 'patient.name'
      },
      {
        Header: 'Phone',
        accessor: 'patient.user.phone'
      },
      {
        Header: 'Doctor',
        accessor: 'doctor.user.name'
      },
      {
        Header: 'Operator',
        accessor: 'assignee.name'
      },
      {
        Header: 'Mission Number',
        accessor: 'mission_number'
      },
      {
        Header: 'Patient Number',
        accessor: 'patient.patient_number'
      },
      {
        Header: 'Factory Name',
        accessor: 'factory_name'
      },
      {
        Header: 'Mission Mode',
        accessor: 'mission_mode'
      }, 
      {
        id: 'counselling',   
        Header: 'Counselling',
        accessor: d =>  d.counselling ? 'Yes' : 'No'
      },
      {
        id: 'covid_related',
        Header: 'Covid Related',
        accessor: d => d.covid_related ? 'Yes' : 'No'
      },
      {
        Header: 'Symptoms',
        accessor: 'initial_conditions'
      },
      {
        id: 'status',
        Header: 'Status',
        accessor: d => d.status
      }
    ];

    let {
      missions,
      sortPref,
      pageSize,
      comment,
      review,
      reviewDialogOpen,
      endMissionDialogOpen,
      reopenMissionDialogOpen,
      startDate,
      endDate,
      docNamesSet,
      opNamesSet,
      patNamesSet,
      callerPhonesSet,
      missionNumSet,
      symptomsSet,
      counsellingSet,
      covidRelatedSet,
      callerPhone,
      docName,
      opName,
      patName,
      symptom,
      missionNumber,
      options,
      selectedCounselling,
      selectedCovidRelated
    } = this.state;

    let {isLoading} = this.props.application;
    let reactTableProps = {
      data: missions.toArray(),
      columns,
      isLoading,
      defaultSorted: sortPref,
      defaultPageSize: pageSize,
      onSortedChange: this.onSortedChange.bind(this),
      onPageSizeChange: this.onPageSizeChange.bind(this),
      noDataText: 'No mission found',
      onFilteredChange: (column, value) => {

      },
      getTdProps: (state, rowInfo) => {
        return {
          onClick: e => {
            if (rowInfo)
              this.setState({
                selectedMission: rowInfo.original,
                missionDetailsDialogOpen: true
              });
          }
        }
      }
    };
    let title = `Missions`;
    return (
      <div>
        <div className="row">
          <div className="column">
            <DatePicker
              value={startDate}
              floatingLabelText="From"
              firstDayOfWeek={0}
              onChange={this.onDateChange.bind(this, 'startDate')}
            />
          </div>
          <div className="column">
            <DatePicker
              value={endDate}
              shouldDisableDate={d =>
                (new Date(d.getTime() - startDate.getTime())).getMonth() >= 3
              }
              floatingLabelText="To"
              firstDayOfWeek={0}
              onChange={this.onDateChange.bind(this, 'endDate')}
            />
          </div>
          <div className="column">
            <TextField
              floatingLabelText="Patient's name"
              value={patName}
              list="patList"
              onChange={this.handleChange.bind(this, 'patName')}
            />
            <datalist id="patList">
              {[...patNamesSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>
          <div className="column">
            <TextField
              floatingLabelText="Doctor's name"
              value={docName}
              list="docList"
              onChange={this.handleChange.bind(this, 'docName')}
            />
            <datalist id="docList">
              {[...docNamesSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>
          <div className="column">
            <TextField
              floatingLabelText="Operator's name"
              value={opName}
              list="opList"
              onChange={this.handleChange.bind(this, 'opName')}
            />
            <datalist id="opList">
              {[...opNamesSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>
          <div className="column">
            <TextField
              floatingLabelText="Caller's phone"
              value={callerPhone}
              list="callerPhoneList"
              onChange={this.handleChange.bind(this, 'callerPhone')}
            />
             <datalist id="callerPhoneList">
              {[...callerPhonesSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>
          <div className="column">
            <TextField
              floatingLabelText="Mission Number"
              value={missionNumber}
              list="missionNumList"
              onChange={this.handleChange.bind(this, 'missionNumber')}
            />
             <datalist id="missionNumList">
              {[...missionNumSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>

           <div className="column">
            <TextField
              floatingLabelText="Symptoms"
              value={symptom}
              list="symptomList"
              onChange={this.handleChange.bind(this, 'symptom')}
            />
            <datalist id="symptomList">
              {[...symptomsSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>

          <div className="column">
            <SelectField
              floatingLabelText="Counselling"
              value={selectedCounselling}
              list="counsellingList"
              onChange={this.handleCounsellingSelect}
            >
              {
                options.map( d=> 
                  <MenuItem
                   primaryText={d}
                    key={d.id}
                    value={d}/>
                  )
              }
            </SelectField>
            <datalist id="counsellingList">
              {[...counsellingSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>

           <div className="column">
            <SelectField
              floatingLabelText="Covid Related"
              value={selectedCovidRelated}
              list="covidRelatedList"
              onChange={this.handleCovidRelatedSelect}
            >
              {
                options.map( d=> 
                  <MenuItem
                   primaryText={d}
                    key={d.id}
                    value={d}/>
                  )
              }
            </SelectField>
            <datalist id="covidRelatedList">
              {[...covidRelatedSet].map(name => <option key={name} value={name} />)}
            </datalist>
          </div>  
        </div>
       <div className="row">
       <div className="col-8"></div>
       <div className="col-4">
          <RaisedButton
            label="Get Missions"
            disabled={!startDate || !endDate}
            primary={true}
            style={{marginRight:'10px'}}
            onClick={this.getMissions.bind(this)}
          />
          <RaisedButton
            label="Download Missions"
            backgroundColor={green500}
            labelColor={white}
            onClick={this.getMissions.bind(this)}
          />
        </div>
        </div>
        <List
          title={title}
          reactTableProps={reactTableProps}
          noFilter={true}
        />
        <MissionDetailsDialog
          comment={comment}
          review={review}
          endMission={this.endMission.bind(this)}
          onChange={this.handleChange.bind(this)}
          submitReview={this.submitReview}
          toggleReviewDialog={this.toggleReviewDialog}
          mission={this.state.selectedMission}
          reviewDialogOpen={reviewDialogOpen}
          endMissionDialogOpen={endMissionDialogOpen}
          reopenMissionDialogOpen={reopenMissionDialogOpen}
          open={this.state.missionDetailsDialogOpen}
          reopenMission={this.reopenMission.bind(this)}
          uploadPrescription={this.uploadPrescription}
          uploadReport={this.uploadReport}
          deleteReport={this.deleteReport}
          toggleTestMissionFlag={this.toggleTestMissionFlag.bind(this)}
          toggleEndMissionDialog={this.toggleEndMissionDialog.bind(this)}
          toggleReopenMissionDialog={this.toggleReopenMissionDialog.bind(this)}
          toggleMissionDetailDialog={this.toggleMissionDetailDialog.bind(this)}
          startInvestigation={this.startInvestigation.bind(this)}
          endInvestigation={this.endInvestigation.bind(this)}
        />
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(MissionList);


// WEBPACK FOOTER //
// ./src/containers/missions.js